import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { GalleryManager } from "@/pages/admin/GalleryManager";
import { EventsManager } from "@/pages/admin/EventsManager";
import { BlogManager } from "@/pages/admin/BlogManager";
import { InquiriesManager } from "@/pages/admin/InquiriesManager";
import { DonationsManager } from "@/pages/admin/DonationsManager";
import { AboutContentManager } from "@/pages/admin/AboutContentManager";
import { ProgramsContentManager } from "@/pages/admin/ProgramsContentManager";
import { HomeContentManager } from "@/pages/admin/HomeContentManager";
import { LogOut } from "lucide-react";

export default function AdminDashboard() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div data-testid="admin-dashboard-page" className="min-h-screen bg-secondary pt-24 pb-16 px-5 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-heading text-2xl md:text-3xl">Content Dashboard</h1>
            <p className="text-muted-foreground text-sm mt-1">Signed in as {user?.email}</p>
          </div>
          <Button onClick={handleLogout} data-testid="admin-logout-button" variant="outline" className="rounded-none">
            <LogOut className="h-4 w-4 mr-2" /> Logout
          </Button>
        </div>

        <Tabs defaultValue="home">
          <TabsList data-testid="admin-tabs-list" className="rounded-none bg-background border border-border mb-8 flex-wrap h-auto">
            <TabsTrigger value="home" data-testid="admin-tab-home" className="rounded-none">Home Page</TabsTrigger>
            <TabsTrigger value="gallery" data-testid="admin-tab-gallery" className="rounded-none">Gallery</TabsTrigger>
            <TabsTrigger value="events" data-testid="admin-tab-events" className="rounded-none">Events</TabsTrigger>
            <TabsTrigger value="blog" data-testid="admin-tab-blog" className="rounded-none">Blog</TabsTrigger>
            <TabsTrigger value="about" data-testid="admin-tab-about" className="rounded-none">About Page</TabsTrigger>
            <TabsTrigger value="programs" data-testid="admin-tab-programs" className="rounded-none">Programs Page</TabsTrigger>
            <TabsTrigger value="inquiries" data-testid="admin-tab-inquiries" className="rounded-none">Inquiries</TabsTrigger>
            <TabsTrigger value="donations" data-testid="admin-tab-donations" className="rounded-none">Donations</TabsTrigger>
          </TabsList>
          <TabsContent value="home"><HomeContentManager /></TabsContent>
          <TabsContent value="gallery"><GalleryManager /></TabsContent>
          <TabsContent value="events"><EventsManager /></TabsContent>
          <TabsContent value="blog"><BlogManager /></TabsContent>
          <TabsContent value="about"><AboutContentManager /></TabsContent>
          <TabsContent value="programs"><ProgramsContentManager /></TabsContent>
          <TabsContent value="inquiries"><InquiriesManager /></TabsContent>
          <TabsContent value="donations"><DonationsManager /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
